import React from 'react';
import { useRouter } from 'next/router'
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import {
    Grid,
    Box,
    H2,
    H3,
} from '@saladbob/sassafras'

import Image from '../media/Image';

import { Tournament } from '../../types'

type PropsLabel = {
    tournament: Tournament,
    imageWidth?: number,
    fromNow?: boolean,
}

dayjs.extend(relativeTime);

const TournamentCard: React.FC<PropsLabel> = ({ tournament, imageWidth, fromNow }) => {
    const router = useRouter();

    const handleClick = () => {
        if (!tournament.host) return;
        router.push(`/local/${tournament.host.slug}`);
    }

    return (
        <Grid
            txtColor="white"
            bgColor="secondary700"
            columns={{ phone: '64px 1fr min-content', laptop: `${imageWidth}px 1fr min-content` }}
            columnGap="md"
            role="button"
            onClick={handleClick}
            depth="lg"
            bdWidth={[0, 0, 0, 'lg']}
            bdColor="tertiary"
        >
            <Box>
                {tournament.image && (
                    <Image
                        image={tournament.image}
                        alt={`${tournament.title} Image`}
                        width="100%"
                        size="thumbnail"
                        aspectRatio="1/1"
                    />
                )}
            </Box>
            <Box verticalAlign="center" textAlign="left" padding="sm">
                <H2 uppercase font={{ phone: 'p', laptop: 'h2' }}>{tournament.title}</H2>
                <H3 uppercase font={{ phone: 'p', laptop: 'h3' }} weight="normal" color="tertiary">
                    {dayjs(tournament.start).format('MMM DD')}-{dayjs(tournament.end).format('DD')}
                </H3>
            </Box>

            {fromNow && (
                <Box verticalAlign="center" textAlign="right" pe="md" className="hide-on-mobile">
                    <H3 font="small" weight="normal" color="rgba(255, 255, 255, 0.5)" uppercase nowrap>
                        {dayjs(tournament.start).fromNow(true)} away!
                    </H3>
                </Box>
            )}
        </Grid>
    )
}

TournamentCard.defaultProps = {
    imageWidth: 180,
}

export default TournamentCard;